import { LAYOUTS, POSITION } from "@voltmoney/types";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackType, TagTypeTokens, WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { CreateDisbursementRequest, goBack, OnAmountChange, SetRecommendedAmount, needHelp, amountConfirm, closeErrorModal, fecthMinAmountDetails } from "./action";
import { api } from "../../../configs/api";
import { ConfigTokens, getAppHeader } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import _ from "lodash";
import { getBankPNGUrl, getBorrowerProfile, getContactUsDetails, removeUrlWithoutReload, SHOW_NEW_WITHDRAW_FLOW, showUnpledgeOptMessage } from "../../../configs/utils";
import { LENDER_ID, QUERY_PARAMS, TARGET_PAGES } from "../../../configs/constants";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (availableCreditAmount, accountNumber, bankCode, processingFees, bankName, isFirstJourney, showDisclaimerBanner, height, showNewWithdrawFlow, chargesDue, withdrawalAmount, contactUsDetails, isFromJupiter, showWithdrawUnpledgeMessage) => {
    return {
        layout: {
            id: ROUTE.WITHDRAW_AMOUNT,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: showNewWithdrawFlow ? true : false
            },
            widgets: showNewWithdrawFlow ? ([{ id: "withdrawAmountScreen", type: WIDGET.WITHDRAW_AMOUNT }]) : ([
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                { id: "header", type: WIDGET.HEADER, position: POSITION.ABSOLUTE_TOP },
                { id: "stack", type: WIDGET.STACK },
                { id: "messageSpace", type: WIDGET.SPACE },
                { id: "amountItem", type: WIDGET.INPUT },
                { id: "amountMsgSpace", type: WIDGET.SPACE },
                showDisclaimerBanner ? { id: "card", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {},
                {
                    id: "cardSpace",
                    type: WIDGET.SPACE,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
                { id: "messageSpace3", type: WIDGET.SPACE },
                {
                    id: "continue",
                    type: WIDGET.BUTTON,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
                { id: "messageSpace", type: WIDGET.SPACE },
            ]),
        },
        datastore: {
            withdrawAmountScreen: {
                height,
                availableCash: availableCreditAmount,
                currentErrorType: "",
                message: "",
                showErrorCode: "",
                showErrorModal: false,
                showInfoModal: false,
                currentModalHeight: 288,
                loading: false,
                accountFee: 0,
                chargesDue,
                processingFee: 0,
                GST: 0,
                stampDutyFee: 0,
                contactUsDetails,
                isFromJupiter,
                needHelpAction: {
                    type: ACTION.CONTACT_US,
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                },
                backAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                },
                confirmAmountAction: {
                    type: ACTION.AMOUNT_CONFIRM,
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                    payload: { isFirstJourney, availableCreditAmount },
                },
                closeErrorModal: {
                    type: ACTION.CLOSE_ERROR_MODAL,
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                    payload: {},
                },
                fetchMinAmountDetails: {
                    type: ACTION.FETCH_MIN_AMOUNT_DETAILS,
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                    payload: {},
                },
                withdrawalAmount: withdrawalAmount,
                isInProgressUnpledgingRequest: showWithdrawUnpledgeMessage,
            },
            header: {
                id: 'bt_withdrawAmount_goBack',
                title: "Withdrawal amount",
                leadIcon: "https://reactnative.dev/img/tiny_logo.png",
                isBackButton: true,
                showBackArrowIcon: true,
                type: HeaderTypeTokens.HEADERCTA,
                leftCta: 'Contact Us',
                leftProps: {
                    id: 'txt_FAQ_contactUs',
                    bgColor: ColorTokens.Primary_05,
                    label: 'NEED HELP?',
                    type: TagTypeTokens.SECONDARY,
                    labelColor: ColorTokens.Primary_100,
                    icon: {
                        align: IconAlignmentTokens.left,
                        name: IconTokens.Whatsapp,
                        size: IconSizeTokens.MD,
                    },
                },
                action: {
                    type: ACTION.GO_BACK,
                    payload: {
                        value: "",
                        widgetId: "continue",
                        isResend: false,
                    },
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                },
                leftAction: {
                    type: ACTION.CONTACT_US,
                    payload: {
                        value: '',
                        widgetId: 'continue',
                        isResend: false,
                    },
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                },
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            stack: {
                type: StackType.row,
                alignItems: "center",
                widgetItems: [
                    { id: "text", type: WIDGET.TEXT },
                    { id: "logo", type: WIDGET.IMAGE },
                    { id: "text2", type: WIDGET.TEXT },
                ],
            },
            card: {
                padding: {
                    left: SizeTypeTokens.LG,
                    right: SizeTypeTokens.LG,
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                },
                bgColor: ColorTokens.Yellow_10,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR2,
                },
                widgetItems: isFirstJourney ? [
                    { id: "widgetText", type: WIDGET.TEXT },
                    { id: "widgetText2", type: WIDGET.TEXT },
                    { id: "widgetText3", type: WIDGET.TEXT },
                    { id: "widgetText4", type: WIDGET.TEXT },
                ] : [
                    { id: "widgetText", type: WIDGET.TEXT },
                    { id: "widgetText3", type: WIDGET.TEXT },
                    { id: "widgetText4", type: WIDGET.TEXT },
                ],
            },
            widgetText: {
                label: "Please note",
                color: ColorTokens.Grey_Night,
                fontWeight: "bold",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.XXS
            },
            widgetText2: {
                label: `  \u2022 ₹${processingFees} one-time processing fee will be deducted `,
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XXS,
                fontWeight: '500',
                lineHeight: 16,
                fontFamily: FontFamilyTokens.Inter
            },
            widgetText3: {
                label: "  \u2022 Transfer may take up to 6 banking hours",
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XXS,
                fontWeight: '500',
                lineHeight: 16,
                fontFamily: FontFamilyTokens.Inter
            },
            widgetText4: {
                label: "  \u2022 Requests post 4PM may take up to 12PM of next day",
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XXS,
                fontWeight: '500',
                lineHeight: 16,
                fontFamily: FontFamilyTokens.Inter
            },
            cardSpace: { size: SizeTypeTokens.XL },
            text: { label: "To: ", fontFamily: FontFamilyTokens.Inter, fontWeight: '500', fontSize: FontSizeTokens.XS, lineHeight: 18 },
            logo: {
                uri: getBankPNGUrl(bankCode),
                width: 30,
                height: 30,
            },
            text2: {
                label: `${bankName} XXXX ${accountNumber.substring(accountNumber.length - 4, accountNumber.length)}`,
                fontFamily: FontFamilyTokens.Inter, fontWeight: '500', fontSize: FontSizeTokens.XS, lineHeight: 18
            },
            headerSpace: { size: SizeTypeTokens.XL },
            amountItem: {
                id: 'tf_withdrawAmount_enterAmount',
                isFocus: true,
                onlyNumeric: true,
                placeholder: "",
                type: InputTypeToken.MULTILINE,
                title: "Enter amount",
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                caption: { success: "", error: "" },
                action: {
                    type: ACTION.ON_AMOUNT_CHANGE,
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                    payload: {
                        value: "",
                    },
                },
            },
            amountMsgSpace: { size: SizeTypeTokens.SM },
            interestItem: {
                isFocus: false,
                value: `0`,
                state: InputStateToken.DISABLED,
                keyboardType: KeyboardTypeToken.decimalPad,
                placeholder: "",
                type: InputTypeToken.DEFAULT,
                title: "Monthly Interest",
                caption: { success: "", error: "" },
            },
            interestMessage: {
                label: "Calculated as per your amount.",
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Grey_Smoke,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "400",
            },
            inputSpace: { size: SizeTypeTokens.XXXL },
            continue: {
                id: 'bt_withdrawAmount_confirm',
                label: "Confirm & get OTP",
                type: ButtonTypeTokens.LargeOutline,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.WITHDRAW_AMOUNT,
                    payload: {
                        accountNumber,
                    },
                    routeId: ROUTE.WITHDRAW_AMOUNT,
                },
            },
            messageSpace: { size: SizeTypeTokens.XL },
        },
    };
};
export const withdraw_amountMF = {
    onLoad: async ({ network, instrumentTrack, getHeight, setDatastore }, { availableCreditAmount, target, withdrawalAmount }) => {
        const user = await SharedPropsService.getUser();
        const accountId = user.linkedBorrowerAccounts[0].accountId;
        const processingFees = user.linkedCredits[0].processingCharges;
        const creditId = user.linkedCredits[0].creditId;
        const contactUsDetails = await getContactUsDetails();
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        let showNewWithdrawFlow = false;
        showNewWithdrawFlow = await SHOW_NEW_WITHDRAW_FLOW();
        setTimeout(() => {
            setDatastore(ROUTE.WITHDRAW_AMOUNT, "withdrawAmountScreen", {
                withdrawalAmount: 0
            });
        }, 0);
        let response = await getBorrowerProfile(network);
        await AsyncStorage.removeItem('target');
        if (target && target === TARGET_PAGES.WITHDRAW) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const listOfDisbursalResponse = await network.get(`${api.getListOfDisbursalByCreditId}${creditId}`, { headers: await getAppHeader() });
        const listOfDisbursal = listOfDisbursalResponse.data;
        const isFirstJourney = listOfDisbursal.length === 0;
        // const accountNumber = _.get(
        //   response,
        //   "data.bankDetails.accountNumber",
        //   null
        // );
        const accountNumber = _.get(response, "bankDetails.accountNumber", null);
        // const bankName = _.get(response, "data.bankDetails.bankName", null);
        const bankName = _.get(response, "bankDetails.bankName", null);
        // const bankCode = _.get(response, "data.bankDetails.bankCode");
        const bankCode = _.get(response, "bankDetails.bankCode");
        const showDisclaimerBanner = user?.linkedApplications[0]?.lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
        SharedPropsService.setBankCode(bankCode);
        SharedPropsService.setBankName(bankName);
        SharedPropsService.setConfig(ConfigTokens.IS_FIRST_JOURNEY, isFirstJourney);
        const chargesDue = user?.linkedCredits[0]?.chargesDue;
        const isInProgressUnpledgingRequest = await SharedPropsService.getUnpledgeRequest();
        const showWithdrawMessage = await showUnpledgeOptMessage();
        const showWithdrawUnpledgeMessage = showWithdrawMessage && isInProgressUnpledgingRequest;
        ;
        instrumentTrack('WITHDRAW_AMOUNT_PAGE_VIEWED');
        return Promise.resolve(template(availableCreditAmount, accountNumber, bankCode, processingFees, bankName, isFirstJourney, showDisclaimerBanner, getHeight(), showNewWithdrawFlow, chargesDue, withdrawalAmount, contactUsDetails, isFromJupiter, showWithdrawUnpledgeMessage));
    },
    actions: {
        [ACTION.WITHDRAW_AMOUNT]: CreateDisbursementRequest,
        [ACTION.ON_AMOUNT_CHANGE]: OnAmountChange,
        [ACTION.SET_RECOMENDED_AMOUNT]: SetRecommendedAmount,
        [ACTION.GO_BACK]: goBack,
        [ACTION.CONTACT_US]: needHelp,
        [ACTION.AMOUNT_CONFIRM]: amountConfirm,
        [ACTION.CLOSE_ERROR_MODAL]: closeErrorModal,
        [ACTION.FETCH_MIN_AMOUNT_DETAILS]: fecthMinAmountDetails,
    },
    clearPrevious: true,
};
